import {Component, OnInit, ViewChild} from '@angular/core';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {GraphService} from '../../../services/graph.service';
import {BwGraph} from '../../../models/bwGraph';
import {SelectItem} from 'primeng/api';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {BwGraphCrudComponent} from '../bw-graph-crud/bw-graph-crud.component';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {BwMonitoringFilterCriteria} from '../../../models/filter/bw-monitoring-filter-criteria';
import * as _ from 'lodash';
import {BaseClientComponent} from '../../base-client.component';
import {Table} from 'primeng/table';
import {TechnicalPopService} from '../../../services/technical-pop.service';

@Component({
  selector: 'app-bw-graph-list',
  templateUrl: './bw-graph-list.component.html',
  styleUrls: ['./bw-graph-list.component.scss']
})
export class BwGraphListComponent extends BaseClientComponent implements OnInit {
  @ViewChild('dataTable') dataTable: Table;

  loading = true;
  bwGraphs: BwGraph[] = [];
  filtredBwGraph: BwGraph[];
  cols = [
    {field: 'originPop', header: 'Origin pop', type: 'string', sortable: false, width: '20%'},
    {field: 'destinationPop', header: 'Destination pop', type: 'string', sortable: false, width: '20%'},
    {field: 'vvlanId', header: 'Vvlan id', type: 'string', sortable: false, width: '20%'},
    {field: 'uniqId', header: 'Uniq id', type: 'string', sortable: false, width: '20%'},
    {field: 'lastUpdatedAt', header: 'Last updated at', type: 'string', sortable: false, width: '20%'},
  ];
  error: boolean;
  errorMessage: string;
  successDelete: boolean;
  bwMonitoringFilterCriteria: BwMonitoringFilterCriteria;
  userChoicesDefaultFilters = {
    originPop: null,
    destinationPop: null,
    vvlanId: null,
    uniqId: null,
    dateFrom: null,
    dateTo: null,
  };
  userChoicesActiveFilters = _.clone(this.userChoicesDefaultFilters);
  destinationPopList: SelectItem[] = [];
  originPopList: SelectItem[] = [];
  vvlanIdList: SelectItem[] = [];
  uniqIdList: SelectItem[] = [];
  records: number;

  constructor(
    private graphService: GraphService,
    private utilsService: UtilsService,
    public dialogService: DialogService,
    protected technicalPopService: TechnicalPopService,
    private authenticationService: AuthenticationService) {
    super();
  }

  ngOnInit() {
    if (this.authenticationService.userCurrent.roles.includes('ROLE_MCKAY_SUPER')) {
      this.cols.push(
        {field: 'actions', header: 'Actions', type: 'string', sortable: false, width: '20%'}
      );
    }
    this.userChoicesActiveFilters = this.utilsService.loadUserPref('downloadLogFilter', this.userChoicesActiveFilters);
    this.bwMonitoringFilterCriteria = new BwMonitoringFilterCriteria(this.userChoicesActiveFilters);
    this.utilsService.lockUi();

    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.retrieveBwGraphs();
    });
    this.subscriptions.push(response$);
  }

  addBwGraph() {
    const header = 'New BW Graph';
    const ref = this.dialogService.open(BwGraphCrudComponent, {
      width: '30%',
      dismissableMask: true,
      header: header,
      data: {
        isNewGraph: true,
        existingGraphs: this.bwGraphs
      },
    });
    this.popUpOnClose(ref, true);
  }

  editBwGraph(bwGraph: BwGraph) {
    const header = 'Edit BW Graph';
    const ref = this.dialogService.open(BwGraphCrudComponent, {
      width: '30%',
      dismissableMask: true,
      header: header,
      data: {
        isNewGraph: false,
        graph: bwGraph
      },
    });
    this.popUpOnClose(ref, false);
  }

  delete(bwGraph: BwGraph) {
    if (!confirm('Deleting a BW Graph will result in deleting all its data. Do you want to proceed?')) {
      return;
    }

    this.graphService.deleteBwGraph(bwGraph.id).subscribe({
        next: () => {
          this.successDelete = true;
          this.bwGraphs = this.bwGraphs.filter(graph =>
            graph.uniqId !== bwGraph.uniqId
            || graph.originPop !== bwGraph.originPop);
        },
        error: error => {
          this.error = true;
          this.errorMessage = error.message;
        }
      }
    );
  }

  filter() {
    if (this.bwGraphs) {
      this.utilsService.saveUserData('bwGraphListFilter',
        {
          'originPop': this.bwMonitoringFilterCriteria.originPop,
          'destinationPop': this.bwMonitoringFilterCriteria.destinationPop,
          'vvlanId': this.bwMonitoringFilterCriteria.vvlanId,
          'uniqId': this.bwMonitoringFilterCriteria.uniqId,
          'dateFrom': this.bwMonitoringFilterCriteria.dateFrom,
          'dateTo': this.bwMonitoringFilterCriteria.dateTo
        });
      this.filtredBwGraph = [];
      this.filtredBwGraph = this.bwGraphs;
      this.filterByUniqId();
      this.filterByOriginPop();
      this.filterByDestinationPop();
      this.filterByVvlanId();
    }
    this.resetDataWithFromDate();
    this.resetDataWithToDate();
    this.records = this.filtredBwGraph ? this.filtredBwGraph.length : 0;
    this.dataTable.reset();
  }

  resetDataWithFromDate() {
    if (!this.bwMonitoringFilterCriteria.dateFrom) {
      return;
    }
    this.filtredBwGraph =
      this.filtredBwGraph.filter(key => new Date(key.lastUpdated) >= new Date(this.bwMonitoringFilterCriteria.dateFrom));

  }

  resetDataWithToDate() {
    if (!this.bwMonitoringFilterCriteria.dateTo) {
      return;
    }
    this.filtredBwGraph =
      this.filtredBwGraph.filter(key => {
        const lastUpdated = new Date(key.lastUpdated);
        const dateTo = new Date(this.bwMonitoringFilterCriteria.dateTo);
        lastUpdated.setHours(0, 0, 0, 0);
        dateTo.setHours(0, 0, 0, 0);
        return lastUpdated <= dateTo;
      });
  }

  resetTable() {
    this.utilsService.saveUserData('bwGraphFilter', this.userChoicesDefaultFilters);
    this.bwMonitoringFilterCriteria = new BwMonitoringFilterCriteria(this.userChoicesActiveFilters);
    this.filtredBwGraph = this.bwGraphs;

  }

  setFilterValues() {
    const distinctOriginPopList = new Set();
    const distinctDestinationPopList = new Set();
    const distinctVvlanList = new Set();
    const distinctUniqIdList = new Set();
    for (const bwGraph of this.bwGraphs) {
      distinctOriginPopList.add(bwGraph.originPop);
      distinctDestinationPopList.add(bwGraph.destinationPop);
      distinctVvlanList.add(bwGraph.vvlanId);
      distinctUniqIdList.add(bwGraph.uniqId);
    }
    this.originPopList = Array.from(distinctOriginPopList).sort().map(label => ({label, value: label} as SelectItem));
    this.destinationPopList = Array.from(distinctDestinationPopList).sort().map(label => ({
      label,
      value: label
    } as SelectItem));
    this.vvlanIdList = Array.from(distinctVvlanList).sort().map(label => ({label, value: label} as SelectItem));
    this.uniqIdList = Array.from(distinctUniqIdList).sort().map(label => ({label, value: label} as SelectItem));
    this.originPopList.unshift({label: 'ALL', value: null});
    this.destinationPopList.unshift({label: 'ALL', value: null});
    this.vvlanIdList.unshift({label: 'ALL', value: null});
    this.uniqIdList.unshift({label: 'ALL', value: null});
  }

  private filterByOriginPop() {
    if (this.bwMonitoringFilterCriteria.originPop === 'ALL' || this.bwMonitoringFilterCriteria.originPop === null) {
      return;
    }
    this.filtredBwGraph = this.filtredBwGraph.filter(bwGrap => bwGrap.originPop === this.bwMonitoringFilterCriteria.originPop);
  }

  private filterByDestinationPop() {
    if (this.bwMonitoringFilterCriteria.destinationPop === 'ALL' || this.bwMonitoringFilterCriteria.destinationPop === null) {
      return;
    }
    this.filtredBwGraph = this.filtredBwGraph.filter(bwGrap => bwGrap.destinationPop === this.bwMonitoringFilterCriteria.destinationPop);

  }

  private filterByVvlanId() {
    if (this.bwMonitoringFilterCriteria.vvlanId === 'ALL' || this.bwMonitoringFilterCriteria.vvlanId === null) {
      return;
    }
    this.filtredBwGraph = this.filtredBwGraph.filter(bwGrap => bwGrap.vvlanId === this.bwMonitoringFilterCriteria.vvlanId);
  }

  private filterByUniqId() {
    if (this.bwMonitoringFilterCriteria.uniqId === 'ALL' || this.bwMonitoringFilterCriteria.uniqId === null) {
      return;
    }
    this.filtredBwGraph = this.filtredBwGraph.filter(bwGrap => bwGrap.uniqId === this.bwMonitoringFilterCriteria.uniqId);
  }

  private retrieveBwGraphs() {
    this.graphService.getBwGraphs().subscribe({
        next: res => {
          this.bwGraphs = res;
          this.setFilterValues();
          this.filtredBwGraph = [];
          this.filtredBwGraph.push(...this.bwGraphs);
          this.records = this.filtredBwGraph ? this.filtredBwGraph.length : 0;

          this.loading = false;
          this.utilsService.unlockUi();
        },
        error: error => {
          this.error = true;
          this.errorMessage = error.message;
        }
      }
    );
  }

  private popUpOnClose(ref: DynamicDialogRef, isNewGraph) {
    if (!ref) {
      return;
    }
    ref.onClose.subscribe(res => {
      if (!res) {
        return;
      }
      if (isNewGraph) {
        this.bwGraphs.push(res);
        return;
      }
      const bwGraph = this.bwGraphs.filter(graph => graph.uniqId === res.uniqId)[0];
      bwGraph.destinationPop = res.destinationPop;
      bwGraph.originPop = res.originPop;
      bwGraph.vvlanId = res.vvlanId;
    });
  }

}
